module.exports = __webpack_public_path__ + "img/1625039459.c9221944.jpeg";